import { FaFacebookMessenger } from 'react-icons/fa';

/**
 * Floating action button that opens/closes the messenger.
 * @param {{ isOpen: boolean, unreadCount: number, onClick: () => void, position: { x: number, y: number }, onPointerDown, onPointerMove, onPointerUp, isDragging: boolean }} props
 */
export function MessengerFAB({
  isOpen,
  unreadCount,
  onClick,
  position,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  isDragging = false,
}) {
  return (
    <button
      type="button"
      className={`responder-messenger-fab${!isOpen ? ' can-drag' : ''}${isDragging ? ' is-dragging' : ''}`}
      aria-label={isOpen ? 'Close messenger' : 'Open messenger'}
      onClick={onClick}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        right: 'auto',
        bottom: 'auto',
      }}
    >
      <FaFacebookMessenger size={20} />
      {unreadCount > 0 && <span className="responder-messenger-fab__badge">{unreadCount}</span>}
    </button>
  );
}
